import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-50 font-sans selection:bg-red-600/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <About data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}